import type { MessageDescriptor } from 'react-intl';
import { useIntl as originalUseIntl } from 'react-intl';
import type { TranslationKey } from '../utils/i18n';

export type ChangeTypeOfKeys<T extends object, Keys extends keyof T, NewType> = {
  [key in keyof T]: key extends Keys ? NewType : T[key];
};

const useIntl = () => {
  const intl = originalUseIntl();
  const formatMessage = (messageDescriptor: ChangeTypeOfKeys<MessageDescriptor, 'id', TranslationKey>) =>
    intl.formatMessage(messageDescriptor);

  return { ...intl, formatMessage };
};

export default useIntl;
